import {useQuery} from '@tanstack/react-query';
import {FullTokenInfo, tokensApi} from '@/api-requests/tokens';
import {HistoryItem, pricingApi} from '@/api-requests/pricing';

export type PriceHistoryData = FullTokenInfo & {
  priceHistory: HistoryItem;
};

const ONE_DAY = 24 * 60 * 60 * 1000;
const ONE_HOUR = 60 * 60;

export const usePriceHistory = (assets: string[]) => {
  return useQuery<PriceHistoryData[]>({
    queryKey: ['price-histories', assets.join(',')],
    enabled: !!assets.length,
    staleTime: 30 * 60 * 1000,
    refetchInterval: 30 * 60_000, // TODO update this one
    queryFn: async () => {
      const from =
        Math.floor((Date.now() - 60 * ONE_DAY) / 1000 / ONE_HOUR) * ONE_HOUR;

      const [priceHistories, tokenInfo] = await Promise.all([
        pricingApi.getPriceHistories(assets, from),
        tokensApi.getTokenInfo(...assets),
      ]);

      return (
        assets.map((asset): PriceHistoryData => {
          const result = priceHistories[asset];
          const info = tokenInfo[asset];

          if ('error' in result) {
            throw new Error(result.stack);
          }

          if ('error' in info) {
            throw new Error(JSON.stringify(info));
          }

          return {
            ...info,
            priceHistory: result,
          };
        }) || []
      );
    },
  });
};
